/* eslint-disable react-hooks/exhaustive-deps */
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import Utils from "../utility/utility";
import { STRING } from "../constants/string";
import { useNavigate, useParams } from "react-router-dom";
import { viewTrackerActionRequest } from "../redux/action/viewTrackerAction";
import { SkeletonForm, SkeletonSwap } from "../components/Skeleton";
import { postApiCall } from "../service/PostApiCall";
import { CREATE_TRACKERS, TRACKER_UPDATE, TRACKER_HELPER } from "../service/apiUrl";
import LoadingButton from "../components/LoadingButton";

const FieldError = ({ msg }) => (
  <span className={"field-error" + (msg ? " is-shown" : "")}>{msg || ""}</span>
);

const AddTracker = (props) => {
  const [errors, setErrors] = useState({});
  const [platform, setPlatform] = useState("");
  const [name, setName] = useState("");
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [profileLink, setProfileLink] = useState("");
  const [platformValue, setplatformValue] = useState("");
  const [nameformValue, setnameformValue] = useState("");
  const [helperData, setHelperData] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getid = useParams();
  const signdata = useSelector((state) => state.signinReducers);
  const viewTracker = useSelector((state) => state.viewTrackerReducers);

  const access_token = signdata?.data?.access_token;
  const user_id = signdata?.data?.id;

  useEffect(() => {
    postApiCall([], access_token, TRACKER_HELPER)
      .then((result) => {
        setHelperData(result);
      })
      .catch((error) => {
        console.error("TRACKER_HELPER", error);
      });
  }, []);

  useEffect(() => {
    const parms = {
      access_token: access_token,
      id: getid?.tracker_id ?? "",
    };

    if (getid && getid.tracker_id) {
      dispatch(viewTrackerActionRequest(parms));
    }
  }, [getid]);

  useEffect(() => {
    setplatformValue(viewTracker?.data?.platform?.id ?? '');
    setnameformValue(viewTracker?.data?.platform?.name ?? '');
    setName(viewTracker?.data?.name ?? '');
    setUserName(viewTracker?.data?.username ?? '');
    setPassword(viewTracker?.data?.password ?? '');
    setProfileLink(viewTracker?.data?.profile_link ?? '');
  }, [viewTracker]);
  
  const validation = () => {
    let message = "";
        const e = {};
    if (Utils.isEmpty(nameformValue)) e.nameformValue = STRING.PLATFORM;
    if (Utils.isEmpty(name)) e.name = STRING.NAME;
    if (Utils.isEmpty(username)) e.username = STRING.USERNAME;
    if (Utils.isEmpty(password)) e.password = STRING.ENTER_PASSWORD;
    else if (password.length < 6) e.password = STRING.ENTER_SIX_DIGIT_PASSWORD;
    if (Utils.isEmpty(profileLink)) e.profileLink = STRING.PROFILE_LINK;
    setErrors(e);
    message = Object.keys(e).length ? "invalid" : "";

    return message;
  };
  const trackeradd = () => {
    const message = validation();
    if (message) {
      return false;
    } else {
      const objectdata = {
        name: name,
        platform: platformValue,
        username: username,
        password: password,
        profile_link: profileLink,
        created_by: user_id,
      };

      return postApiCall(objectdata, access_token, CREATE_TRACKERS).then(
        (response) => {
          Utils.toast("success", "Tracker created successfully!");
          navigate("/manage-tracker");
        }
      );
    }
  };

  const trackerupdate = () => {
    const message = validation();
    if (message) {
      return false;
    } else {
      const updatedata = {
        name: name,
        platform: platformValue,
        username: username,
        password: password,
        profile_link: profileLink,
        created_by: user_id,
        id: getid?.tracker_id,
      };
      return postApiCall(updatedata, access_token, TRACKER_UPDATE, navigate).then(
        (response) => {
          Utils.toast("success", "Tracker updated successfully!");
          navigate("/manage-tracker");
        }
      );
    }
  };

  return (
    <>
      <div className={props?.data?.transtion == true ? "contents" : "content"}>
        <div className="content-top-spacer"></div>
        <div className="color-body">
          <div className="page-head">
            <div className="page-eyebrow">Tracking</div>
            <h1 className="page-title">Add Tracker</h1>
          </div>
          <div className="col-md-6 manage">
            <SkeletonSwap
              loaded={!(viewTracker?.isLoading == true)}
              skeleton={
              <div className="card-input mt-5 mb-2">
                <SkeletonForm fields={5} columns={2} />
              </div>
              }
            >
              <div className="card-input mt-5 mb-2">
                <div className="col-md-12">
                  <div className="mt-3">
                    <h5>Create Tracker</h5>
                  </div>
                  <form>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label
                            htmlFor="exampleInputEmail1"
                            className={platform == "" ? "text-danger" : ""}
                          >
                            Platform
                          </label>
                          <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                            options={helperData?.sources}
                            value={{
                              label: nameformValue,
                              value: platformValue,
                            }}
                            placeholder="Please Select A Platform"
                            onChange={(platform) => {
                              setplatformValue(platform.value);
                              setnameformValue(platform.label);
                            }}
                          />
<FieldError msg={errors.nameformValue} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Name</label>
                          <input
                            type="text"
                            className={"form-control" + (errors.name ? " is-invalid" : "")}
                            value={name}
                            onChange={(name) => {
                              setName(name.target.value);
                            }}
                            // placeholder="Enter Project Owner"
                          />
<FieldError msg={errors.name} />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Username</label>
                          <input
                            type="text"
                            className={"form-control" + (errors.username ? " is-invalid" : "")}
                            value={username}
                            onChange={(username) => {
                              setUserName(username.target.value);
                            }}
                            // placeholder="Enter Project Name"
                          />
<FieldError msg={errors.username} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Password</label>
                          <input
                            type="Password"
                            className={"form-control" + (errors.password ? " is-invalid" : "")}
                            value={password}
                            onChange={(password) => {
                              setPassword(password.target.value);
                            }}
                            // placeholder="Enter Project Name"
                          />
<FieldError msg={errors.password} />
                        </div>
                      </div>
                      <div className="col-md-6 mt-2">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">
                            Profile Link
                          </label>
                          <input
                            type="text"
                            className={"form-control" + (errors.profileLink ? " is-invalid" : "")}
                            value={profileLink}
                            onChange={(Profile) => {
                              setProfileLink(Profile.target.value);
                            }}
                            // placeholder="Enter Project Name"
                          />
<FieldError msg={errors.profileLink} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="row mb-5 mt-3">
                        <div className="">
                          {getid && getid?.tracker_id ? (
                            <LoadingButton
                              className="create-button"
                              successLabel="Saved"
                              onAction={trackerupdate}
                            >
                              Update
                            </LoadingButton>
                          ) : (
                            <LoadingButton
                              className="create-button"
                              successLabel="Submitted"
                              onAction={trackeradd}
                            >
                              Submit
                            </LoadingButton>
                          )}
                        </div>
                        <div className="ml-2">
                          <button
                            type="button"
                            className="create-button1 btn-info"
                            onClick={()=>navigate("/manage-tracker")}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </SkeletonSwap>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTracker;
